import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

function WorkingPhoto(): React.ReactElement {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "mark_working-min.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1024) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      style={{ borderRadius: 6 }}
      fluid={data.placeholderImage.childImageSharp.fluid}
    />
  )
}

export default WorkingPhoto
